//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InTitle from "@/views/stencil/components/title";
import { InsurStore } from "../../store";
import Editor from "@/views/stencil/components/editor";
import { get } from "lodash";
import Tab from "@/views/stencil/present/components/tab.vue";

export default {
  name: "InDetails",
  props: {
    showScheme: {
      type: Object,
    },
  },
  data() {
    return {
      show: false,
      selectedSchemeIndex: null,
    };
  },
  components: {
    InTitle,
    Editor,
    Tab,
  },
  computed: {
    insurance() {
      return InsurStore.insurance;
    },
    schemeServiceList() {
      const list = get(this.insurance, "schemeServiceList");
      console.log(list, "list");
      return Array.isArray(list) ? list : [];
    },
    selectedScheme() {
      return get(this.schemeServiceList, this.selectedSchemeIndex, null);
    },
  },
  created() {
    if (this.showScheme && this.showScheme.schemeCode) {
      let selectedSchemeIndex = 0;
      this.schemeServiceList.forEach((item, index) => {
        if (item.schemeCode === this.showScheme.schemeCode) {
          selectedSchemeIndex = index;
        }
      });
      this.selectedSchemeIndex = selectedSchemeIndex;
    }
  },
  methods: {
    details() {
      this.STATISTICS_CONFIG.insur_proinfo_insurdetail_click();
      this.show = true;
    },
  },
};
